export enum PageTheme {
  light = 'theme-light',
  dark = 'theme-dark',
}
